import React, { FC } from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { CustomStyledDatePicker } from './DatePicker.styles';

interface CustomDatePickerProps {
  onChange?: (date: dayjs.Dayjs | null) => void;
  defaultValue?: dayjs.Dayjs | null;
  disabledDate?: (current: dayjs.Dayjs) => boolean;
}

export const CustomDatePicker: FC<CustomDatePickerProps> = ({
  onChange,
  defaultValue,
  disabledDate,
}) => {
  const { t } = useTranslation();
  const defaultDisabled = (current: dayjs.Dayjs) => {
    return current && current.isBefore(dayjs().startOf('day'), 'day');
  };

  const combinedDisabledDate = (current: dayjs.Dayjs) => {
    return defaultDisabled(current) || (disabledDate ? disabledDate(current) : false);
  };

  // styled() drops antd's picker generic, so the value arrives typed as unknown
  const handleChange = (date: unknown) => {
    if (onChange) onChange(date as dayjs.Dayjs | null);
  };

  return (
    <CustomStyledDatePicker
      data-testid="schedule-date-picker"
      placeholder={t('shared.datePicker.placeholder')}
      value={defaultValue || null}
      onChange={handleChange}
      disabledDate={combinedDisabledDate}
    />
  );
};
